export const PROFESSIONAL_FIELDS = [
  { id: 'INFORMATIK', label: 'Informatik' },
  { id: 'MEDIAMATIK', label: 'Mediamatik' },
  { id: 'KV', label: 'KV' },
  { id: 'KUNDENDIALOG', label: 'Kundendialog' },
  { id: 'DETAILHANDEL', label: 'Detailhandel' },
];

export const APP_NAME = 'Journey';
